import PropTypes from 'prop-types';
import React from 'react';

import { getQuestionAggregate, getQuestionInfo } from 'questions';

import Report from './Report';

const ReportContainer = ({ aggregatedStudyAnswers, ...props }) => {
  const aggregateComponents = aggregatedStudyAnswers.map((question) =>
    getQuestionAggregate(question.question.type),
  );
  const questionInfos = aggregatedStudyAnswers.map((aggregatedStudyAnswer) =>
    getQuestionInfo(aggregatedStudyAnswer.question.type),
  );
  return (
    <Report
      aggregatedStudyAnswers={aggregatedStudyAnswers}
      questionInfos={questionInfos}
      aggregateComponents={aggregateComponents}
      {...props}
    />
  );
};

ReportContainer.propTypes = {
  aggregatedStudyAnswers: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ReportContainer;
